import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m13.333 5.341-4-3.506a2 2 0 0 0-2.667 0l-4 3.506A2 2 0 0 0 2 6.848v5.827a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V6.84a2 2 0 0 0-.667-1.5m-4 8H6.666v-3.333a.667.667 0 0 1 .667-.667h1.333a.667.667 0 0 1 .667.667zm3.333-.666a.667.667 0 0 1-.666.666h-1.334v-3.333a2 2 0 0 0-2-2H7.333a2 2 0 0 0-2 2v3.333H4a.666.666 0 0 1-.667-.666V6.84a.67.67 0 0 1 .227-.5l4-3.5a.67.67 0 0 1 .88 0l4 3.5a.67.67 0 0 1 .226.5z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })